var FeatureModal = (function () {


  var $featureModal;
  var $svgClose;
  var $body;
  var interval;
  var spinner;
  var svgCloseHtml;

  function attachFetch() {
    $featureModal = $('.acr-feature-modal');
    $svgClose = $('.acr-icon.feature-modal-close');
    var $modalAnchors = $('[data-acr-feature-modal]');

    $modalAnchors.off('click', fetch)
      .on('click', fetch);
  }

  function fetch(e) {
    e.preventDefault();

    $featureModal.find('.feature-modal-window').html(spinner);
    $featureModal.addClass('visible');

    Utility.removeClassFromSvg($svgClose, 'hide');
    svgCloseHtml = $svgClose[0].outerHTML;
    Utility.addClassToSvg($svgClose, 'hide');

    if (!$(this).hasClass('is-modal-content')) {
      $.get($(this).attr('href') + '?stub=1', function (data) {
        $featureModal.find('.animated-spinner').removeClass('visible');
        $featureModal.find('.feature-modal-window').html(data);

        if ($('html').hasClass('ie')) {
          setTimeout(waitImage, 400);
        } else {
          layout();
          Disclaimer.init();
        }

        attachModalDeeplinks();
      });
    } else {
      var modalContent = '<div class="acr-modal-page-container">'
                            + '<div class="collapse-content">'
                              + '<div class="header">'
                                + '<h5 class="header-name">' + $(this).attr('data-title') + '</h5>'
                                + svgCloseHtml
                              + '</div>'
                              + '<div class="content-container">'
                                + '<picture>'
                                  + '<img src="' + $(this).attr('data-image') + '">'
                                + '</picture>'
                                + '<div class="content">'
                                  + '<div class="description">'
                                    + $(this).attr('data-description')
                                  + '</div>'
                                + '</div>'
                              + '</div>'
                            + '</div>'
                          + '</div>';

      $featureModal.find('.feature-modal-window').html(modalContent);

      if ($('html').hasClass('ie')) {
        setTimeout(waitImage, 400);
      } else {
        layout();
        Disclaimer.init();
      }
    }
  }

  function attachClicks() {
    $(document).off('click',
      '.acr-feature-modal .acr-icon.feature-modal-close', closeHandler);
    $(document).on('click',
      '.acr-feature-modal .acr-icon.feature-modal-close', closeHandler);

    $(document).off('click',
      '.acr-feature-modal use', closeHandler);
    $(document).on('click',
      '.acr-feature-modal use', closeHandler);

    $featureModal.off('click', closeHandler)
      .on('click', closeHandler);

    $featureModal.find('.feature-modal-window')
      .off('click', stopPropagation)
      .on('click', stopPropagation);
  }

  function attachKeyboardInput() {
    $(document).off('keyup', keyboardHandler)
      .on('keyup', keyboardHandler);
  }

  function attachResize() {
    $(window).off('resize', layout);
    $(window).resize(layout);
  }

  function attachModalDeeplinks() {
    $featureModal.find('a[href*=#]').off('click', closeHandler);
    $featureModal.find('a[href*=#]').on('click', closeHandler);
  }

  function closeHandler() {
    // Enable scrolling.
    document.removeEventListener('touchmove', handleTouchLock);

    $featureModal.removeClass('visible');
    $body.removeClass('modal-open');
  }

  function stopPropagation(e) {
    var $target = $(e.target);
    if (!$target.is('svg') && !$target.is('use') && !$target.is('a')) {
      e.stopPropagation();
    }
  }

  function keyboardHandler(e) {
    if (e.which === 27) { // esc key
      if ($featureModal.hasClass('visible')) {
        closeHandler();
      }
    }
  }

  function handleTouchLock(e) {
    e.preventDefault();
  }

  function layout() {
    var $featureModal = $('.acr-feature-modal');

    if (!$featureModal.hasClass('visible')) {
      return;
    }

    // Disable scrolling.
    document.addEventListener('touchmove', handleTouchLock, { passive: false });

    var windowHeight = window.screen.height;
    var windowWidth = $(window).width();
    var modalPadding = 100; // Modal should have 50px of padding-top and 50px of padding-bottom
    var imgHeight;

    if (windowWidth < Constants.breakpoints.sm) {
      Utility.reevaluatePictureFill();

      var headerHeight = $featureModal.find('.header').height();
      imgHeight = $featureModal.find('img').height();

      if (imgHeight === 0) {
        clearInterval(interval);
        interval = setInterval(layout, 100);
      } else {
        clearInterval(interval);
      }

      $featureModal.find('.content').innerHeight(windowHeight - headerHeight - imgHeight - modalPadding);
    } else {
      var $content = $featureModal.find('.content');
      imgHeight = $featureModal.find('img').height();

      if (imgHeight === 0) {
        clearInterval(interval);
        interval = setInterval(layout, 100);
      } else {
        clearInterval(interval);
      }

      $featureModal.find('.content').innerHeight('auto');

      if (imgHeight > 0 && $content.height() > imgHeight * 1.2) {
        $content.height(imgHeight * 1.2);
      }
    }

    $body.addClass('modal-open');
    setContentScroll();
  }

  function setContentScroll() {
    var modalContent = $featureModal.find('.content');
    try {
      var api = modalContent.data().jsp;
      modalContent.jScrollPane();
    } catch (err) {
      console.warn(err);
    }
  }

  function waitImage() {
    if ($featureModal.find('img').length) {
      var src;
      var srcset;
      var breakPImages;
      var image = new Image();
      var bpCurrent = getCurrentBreakpoint();

      switch (bpCurrent) {
        case 'sm': breakPImages = $featureModal.find('source[media|="(min-width: 550px)"]');
          break;
        case 'lg': breakPImages = $featureModal.find('source[media|="(min-width: 1024px)"]');
          break;
        case 'xl': breakPImages = $featureModal.find('source[media|="(min-width: 1400px)"]');
          break;
        default: breakPImages = $featureModal.find('img');
          break;
      }

      srcset = breakPImages.attr('srcset') || breakPImages.attr('data-srcset');

      src = srcset.split(',');
      src = src[0];

      $featureModal.find('img').attr('src', src);

      image.onload = function () {
        layout();

        Disclaimer.init();
      };

      image.src = src;
    }
  }

  function getCurrentBreakpoint() {
    var size = 'xs';
    var width = window.innerWidth;

    if (width < Constants.breakpoints.sm) {
      size = 'xs';
    } else if (width < Constants.breakpoints.lg) {
      size = 'sm';
    } else if (width < Constants.breakpoints.xl) {
      size = 'lg';
    } else {
      size = 'xl';
    }

    return size;
  }

  function init() {
    $body = $('body');
    $featureModal = $('.acr-feature-modal');
    spinner = $('<div class="animated-spinner-container">'
      + '<div class="animated-spinner"></div></div>');

    attachFetch();
    attachClicks();
    attachKeyboardInput();
    attachResize();

    $(window).on('resize', $.throttle(250, function () {
      setContentScroll();
    }));
    if (Utility.isSafari()) {
      $featureModal.addClass('is-safari');
    }
  }

  return {
    init: init,
  };
}());
